// src/components/SceltaClienteOwner.js
// ═══════════════════════════════════════════════════════════════════════════
// SCELTA DEL CLIENTE NEI DOCUMENTI DEL PLATFORM OWNER (offerte e proforma, W431)
// ═══════════════════════════════════════════════════════════════════════════
// Elenco delle aziende su Nexiora (le stesse del pannello Owner) con ricerca: scelta l'azienda,
// ragione sociale, Partita IVA e sede arrivano dalle Impostazioni aziendali del cliente,
// referente ed email dal titolare. Tutto resta modificabile nel documento (la modifica vale solo
// lì, i dati del cliente non cambiano). «Altro cliente» = non ancora su Nexiora, a mano.
// ═══════════════════════════════════════════════════════════════════════════
import React, { useEffect, useState } from "react";
import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export function useOrganizzazioni() {
  const [orgs, setOrgs] = useState([]);
  useEffect(() => onSnapshot(collection(db, "organizations"), s => setOrgs(s.docs.filter(d => d.id !== "demo-nexiora-org").map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => String(a.name || a.nome || "").localeCompare(String(b.name || b.nome || ""), "it"))), () => setOrgs([])), []);
  return orgs;
}

/** Dati del cliente dall'azienda e dal suo titolare. */
export async function datiClienteDaOrg(org) {
  let t = {};
  if (org?.ownerId) { try { const s = await getDoc(doc(db, "users", org.ownerId)); t = s.exists() ? s.data() : {}; } catch { /* resta vuoto */ } }
  return {
    ragioneSociale: org?.name || org?.nome || "", piva: org?.piva || "", indirizzo: org?.indirizzo || "",
    referente: t.displayName || "", email: org?.email || t.email || "",
  };
}

export default function SceltaCliente({ orgId, orgs, onScegli, soloAziende = false }) {
  const [cerca, setCerca] = useState("");
  const filtrate = orgs.filter(o => !cerca || String(o.name || o.nome || "").toLowerCase().includes(cerca.toLowerCase()));
  const scegli = async (id) => {
    if (!id) { onScegli(null, null); return; }
    const org = orgs.find(o => o.id === id);
    onScegli(await datiClienteDaOrg(org), org);
  };
  const inp = { padding: "7px 9px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 13.5, fontFamily: "inherit", boxSizing: "border-box" };
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 8 }}>
      <div style={{ flex: "1 1 160px" }}>
        <label htmlFor="sc-cerca" style={{ fontSize: 11.5, fontWeight: 700, color: "#374151", display: "block", marginBottom: 3 }}>Cerca azienda</label>
        <input id="sc-cerca" value={cerca} onChange={e => setCerca(e.target.value)} placeholder="Nome dell'azienda" style={{ ...inp, width: "100%" }} />
      </div>
      <div style={{ flex: "2 1 240px" }}>
        <label htmlFor="sc-cliente" style={{ fontSize: 11.5, fontWeight: 700, color: "#374151", display: "block", marginBottom: 3 }}>Cliente</label>
        <select id="sc-cliente" value={orgId || ""} onChange={e => scegli(e.target.value)} style={{ ...inp, width: "100%" }}>
          <option value="">{soloAziende ? "— scegli l'azienda —" : "Altro cliente (non ancora su Nexiora)"}</option>
          {filtrate.map(o => <option key={o.id} value={o.id}>{o.name || o.nome || o.id}</option>)}
          {orgId && !filtrate.some(o => o.id === orgId) && <option value={orgId}>{(orgs.find(o => o.id === orgId) || {}).name || orgId}</option>}
        </select>
      </div>
    </div>
  );
}
